// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_GET_URL_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/getUrl.js");
var ___CSS_LOADER_URL_IMPORT_0___ = require("./static/Roboto-Thin.ttf");
var ___CSS_LOADER_URL_IMPORT_1___ = require("./static/Roboto-LightItalic.ttf");
var ___CSS_LOADER_URL_IMPORT_2___ = require("./static/Roboto-Light.ttf");
var ___CSS_LOADER_URL_IMPORT_3___ = require("./static/Roboto-Medium.ttf");
var ___CSS_LOADER_URL_IMPORT_4___ = require("./static/Roboto-MediumItalic.ttf");
var ___CSS_LOADER_URL_IMPORT_5___ = require("./static/Roboto-Bold.ttf");
var ___CSS_LOADER_URL_IMPORT_6___ = require("./static/Roboto-BoldItalic.ttf");
var ___CSS_LOADER_URL_IMPORT_7___ = require("./static/Roboto-Black.ttf");
var ___CSS_LOADER_URL_IMPORT_8___ = require("./static/Roboto-BlackItalic.ttf");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
var ___CSS_LOADER_URL_REPLACEMENT_0___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_0___);
var ___CSS_LOADER_URL_REPLACEMENT_1___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_1___);
var ___CSS_LOADER_URL_REPLACEMENT_2___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_2___);
var ___CSS_LOADER_URL_REPLACEMENT_3___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_3___);
var ___CSS_LOADER_URL_REPLACEMENT_4___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_4___);
var ___CSS_LOADER_URL_REPLACEMENT_5___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_5___);
var ___CSS_LOADER_URL_REPLACEMENT_6___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_6___);
var ___CSS_LOADER_URL_REPLACEMENT_7___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_7___);
var ___CSS_LOADER_URL_REPLACEMENT_8___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_8___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `@font-face {
   font-family: 'Roboto';
   font-weight: 100;
   font-style: normal;
   src: url(${___CSS_LOADER_URL_REPLACEMENT_0___});
   font-display: swap;
}

@font-face {
   font-family: 'Roboto';
   font-weight: 100;
   font-style: italic;
   src: url(${___CSS_LOADER_URL_REPLACEMENT_1___});
   font-display: swap;
}

@font-face {
   font-family: 'Roboto';
   font-weight: 300;
   font-style: normal;
   src: url(${___CSS_LOADER_URL_REPLACEMENT_2___});
   font-display: swap;
}

@font-face {
   font-family: 'Roboto';
   font-weight: 300;
   font-style: italic;
   src: url(${___CSS_LOADER_URL_REPLACEMENT_1___});
   font-display: swap;
}

@font-face {
   font-family: 'Roboto';
   font-weight: 400;
   font-style: normal;
   src: url(${___CSS_LOADER_URL_REPLACEMENT_2___});
   font-display: swap;
}

@font-face {
   font-family: 'Roboto';
   font-weight: 400;
   font-style: italic;
   src: url(${___CSS_LOADER_URL_REPLACEMENT_1___});
   font-display: swap;
}

@font-face {
   font-family: 'Roboto';
   font-weight: 500;
   font-style: normal;
   src: url(${___CSS_LOADER_URL_REPLACEMENT_3___});
   font-display: swap;
}

@font-face {
   font-family: 'Roboto';
   font-weight: 500;
   font-style: italic;
   src: url(${___CSS_LOADER_URL_REPLACEMENT_4___});
   font-display: swap;
}

@font-face {
   font-family: 'Roboto';
   font-weight: 700;
   font-style: normal;
   src: url(${___CSS_LOADER_URL_REPLACEMENT_5___});
   font-display: swap;
}

@font-face {
   font-family: 'Roboto';
   font-weight: 700;
   font-style: italic;
   src: url(${___CSS_LOADER_URL_REPLACEMENT_6___});
   font-display: swap;
}

@font-face {
   font-family: 'Roboto';
   font-weight: 900;
   font-style: normal;
   src: url(${___CSS_LOADER_URL_REPLACEMENT_7___});
   font-display: swap;
}

@font-face {
   font-family: 'Roboto';
   font-weight: 900;
   font-style: italic;
   src: url(${___CSS_LOADER_URL_REPLACEMENT_8___});
   font-display: swap;
}`, "",{"version":3,"sources":["webpack://./src/css/fonts/Roboto/styles.css"],"names":[],"mappings":"AAAA;GACG,qBAAqB;GACrB,gBAAgB;GAChB,kBAAkB;GAClB,4CAAoC;GACpC,kBAAkB;AACrB;;AAEA;GACG,qBAAqB;GACrB,gBAAgB;GAChB,kBAAkB;GAClB,4CAA2C;GAC3C,kBAAkB;AACrB;;AAEA;GACG,qBAAqB;GACrB,gBAAgB;GAChB,kBAAkB;GAClB,4CAAqC;GACrC,kBAAkB;AACrB;;AAEA;GACG,qBAAqB;GACrB,gBAAgB;GAChB,kBAAkB;GAClB,4CAA2C;GAC3C,kBAAkB;AACrB;;AAEA;GACG,qBAAqB;GACrB,gBAAgB;GAChB,kBAAkB;GAClB,4CAAqC;GACrC,kBAAkB;AACrB;;AAEA;GACG,qBAAqB;GACrB,gBAAgB;GAChB,kBAAkB;GAClB,4CAA2C;GAC3C,kBAAkB;AACrB;;AAEA;GACG,qBAAqB;GACrB,gBAAgB;GAChB,kBAAkB;GAClB,4CAAsC;GACtC,kBAAkB;AACrB;;AAEA;GACG,qBAAqB;GACrB,gBAAgB;GAChB,kBAAkB;GAClB,4CAA4C;GAC5C,kBAAkB;AACrB;;AAEA;GACG,qBAAqB;GACrB,gBAAgB;GAChB,kBAAkB;GAClB,4CAAoC;GACpC,kBAAkB;AACrB;;AAEA;GACG,qBAAqB;GACrB,gBAAgB;GAChB,kBAAkB;GAClB,4CAA0C;GAC1C,kBAAkB;AACrB;;AAEA;GACG,qBAAqB;GACrB,gBAAgB;GAChB,kBAAkB;GAClB,4CAAqC;GACrC,kBAAkB;AACrB;;AAEA;GACG,qBAAqB;GACrB,gBAAgB;GAChB,kBAAkB;GAClB,4CAA2C;GAC3C,kBAAkB;AACrB","sourcesContent":["@font-face {\r\n   font-family: 'Roboto';\r\n   font-weight: 100;\r\n   font-style: normal;\r\n   src: url('./static/Roboto-Thin.ttf');\r\n   font-display: swap;\r\n}\r\n\r\n@font-face {\r\n   font-family: 'Roboto';\r\n   font-weight: 100;\r\n   font-style: italic;\r\n   src: url('./static/Roboto-LightItalic.ttf');\r\n   font-display: swap;\r\n}\r\n\r\n@font-face {\r\n   font-family: 'Roboto';\r\n   font-weight: 300;\r\n   font-style: normal;\r\n   src: url('./static/Roboto-Light.ttf');\r\n   font-display: swap;\r\n}\r\n\r\n@font-face {\r\n   font-family: 'Roboto';\r\n   font-weight: 300;\r\n   font-style: italic;\r\n   src: url('./static/Roboto-LightItalic.ttf');\r\n   font-display: swap;\r\n}\r\n\r\n@font-face {\r\n   font-family: 'Roboto';\r\n   font-weight: 400;\r\n   font-style: normal;\r\n   src: url('./static/Roboto-Light.ttf');\r\n   font-display: swap;\r\n}\r\n\r\n@font-face {\r\n   font-family: 'Roboto';\r\n   font-weight: 400;\r\n   font-style: italic;\r\n   src: url('./static/Roboto-LightItalic.ttf');\r\n   font-display: swap;\r\n}\r\n\r\n@font-face {\r\n   font-family: 'Roboto';\r\n   font-weight: 500;\r\n   font-style: normal;\r\n   src: url('./static/Roboto-Medium.ttf');\r\n   font-display: swap;\r\n}\r\n\r\n@font-face {\r\n   font-family: 'Roboto';\r\n   font-weight: 500;\r\n   font-style: italic;\r\n   src: url('./static/Roboto-MediumItalic.ttf');\r\n   font-display: swap;\r\n}\r\n\r\n@font-face {\r\n   font-family: 'Roboto';\r\n   font-weight: 700;\r\n   font-style: normal;\r\n   src: url('./static/Roboto-Bold.ttf');\r\n   font-display: swap;\r\n}\r\n\r\n@font-face {\r\n   font-family: 'Roboto';\r\n   font-weight: 700;\r\n   font-style: italic;\r\n   src: url('./static/Roboto-BoldItalic.ttf');\r\n   font-display: swap;\r\n}\r\n\r\n@font-face {\r\n   font-family: 'Roboto';\r\n   font-weight: 900;\r\n   font-style: normal;\r\n   src: url('./static/Roboto-Black.ttf');\r\n   font-display: swap;\r\n}\r\n\r\n@font-face {\r\n   font-family: 'Roboto';\r\n   font-weight: 900;\r\n   font-style: italic;\r\n   src: url('./static/Roboto-BlackItalic.ttf');\r\n   font-display: swap;\r\n}"],"sourceRoot":""}]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___;
